import { withProductGridProps } from 'viewModel/catalog/productGrid/withProductGridProps';
import ProductGrid from 'components/Catalog/ProductGrid/ProductGrid';
import { connect } from 'react-redux';
import { createSelector, createStructuredSelector } from 'reselect';
import FrameworkUtils from 'utils/framework';
import LanguageLocaleUtils from 'utils/LanguageLocale';
import NoResultsEN from 'components/Catalog/ProductGrid/NoResults/locales/NoResults_en_US.js';
import NoResultsFR from 'components/Catalog/ProductGrid/NoResults/locales/NoResults_fr_CA.js';
import CatalogEN from 'components/Catalog/locales/Catalog_en_US.js';
import CatalogFR from 'components/Catalog/locales/Catalog_fr_CA.js';

const { wrapHOC } = FrameworkUtils;
const { getTextFromResource, getLocalisedDataFromResource } = LanguageLocaleUtils;
const getNoResultsText = getLocalisedDataFromResource(NoResultsEN, NoResultsFR);
const getText = getLocalisedDataFromResource(CatalogEN, CatalogFR);

const localization = createStructuredSelector({
    compare: getTextFromResource(getText, 'compare'),
    resultsFor: getTextFromResource(getText, 'resultsFor'),
    showMoreProducts: getTextFromResource(getText, 'showMoreProducts'),
    SDDUnavailable: getTextFromResource(getNoResultsText, 'SDDUnavailable'),
    SDDUnavailable2: getTextFromResource(getNoResultsText, 'SDDUnavailable2'),
    noSDDResult: getTextFromResource(getNoResultsText, 'noSDDResult', ['{0}']),
    noSDDResult2: getTextFromResource(getNoResultsText, 'noSDDResult2'),
    noResults1: getTextFromResource(getNoResultsText, 'noResults1'),
    noResults2: getTextFromResource(getNoResultsText, 'noResults2')
});

const fields = createSelector(localization, locales => {
    return {
        locales
    };
});

const withProductGridComponentProps = wrapHOC(connect(fields, null));

export default withProductGridComponentProps(withProductGridProps(ProductGrid));
